import { Spinner } from '@riac/design-system';
import { Button } from '@up-riac/bespoke-ui';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import tz from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(tz);
import React from 'react';
import { AuctionDate } from 'src/components/AuctionDate/AuctionDate';
import { EmptyState } from 'src/components/EmptyState';
import { HeaderMobileMenuHeader } from 'src/components/Header/components/HeaderMobileMenu/HeaderMobileMenuHeader';
import { HeaderMobileMenuNavItem } from 'src/components/Header/components/HeaderMobileMenu/HeaderMobileMenuNavItem';
import { useBackendApiFetch } from 'src/lib/BackendFetchContext';
import { usePrefetchSuspense } from 'src/lib/usePrefetch';

const HeaderMobileMenuConsignmentPageContent = ({ closeMenu }: {closeMenu: () => void}) => {
  const backendApiFetch = useBackendApiFetch();
  const result = usePrefetchSuspense('header-mobile-menu-consignment-page-data', async () => {
    const req = await backendApiFetch('/api/account/consignmentPageInfo', {
      credentials: 'include',
    });
    const info = await (req.json());
    return info;
  });

  const { success, data } = result.read();
  if(!success || !data?.isConsignor) {
    return <EmptyState
      className='mb-5'
      title='You currently have no items for consignment.'
      description='We are the best place to sell your guns! As a firearms auction house, we have one common goal with our consignors: achieve the highest possible price. With that goal in mind, we’re here to answer any questions you may have before getting started.'
    >
      <Button to='/consignment/getting-started' onPress={() => closeMenu()} variant='accent' buttonType='outlined'>
        Start Selling
      </Button>
    </EmptyState>;
  }
  const consignments = data.Content.slice(0, 4);
  return <>
    {consignments.map((consignment: any) => (
      <HeaderMobileMenuNavItem
        key={consignment.ConsignmentID}
        id={`header-mobile-menu-consignment-page-consignment-${consignment.ConsignmentID}-link`}
        label={consignment.Title}
        description={<AuctionDate
          omitIcon
          auction = {consignment}
          startDateFormat = 'MMMM Do'
          endDateFormat={dayjs.tz(consignment.StartDate, 'America/Chicago').format('MMM') === dayjs.tz(consignment.EndDate, 'America/Chicago').format('MMM') ? 'Do, YYYY' : 'MMMM Do, YYYY'}
          omitTime
        />}
        noArrow
      />
    ))}
    <HeaderMobileMenuNavItem id='header-mobile-menu-consignment-page-view-all-link' noArrow to='/account/consignment' label='View All Consignments' onPress={() => closeMenu()}/>
  </>;
};

export const HeaderMobileMenuConsignmentPage = ({ setPage, closeMenu }: {setPage: React.Dispatch<React.SetStateAction<'main' | 'login' | 'auctions' | 'consignment' | 'latest' | 'company' | 'locations' | 'account' | 'account/profile' | 'account/consignment' | 'account/settings' | 'account/buying'>>, closeMenu: () => void}) => {
  return <>
    <HeaderMobileMenuHeader
      id='header-mobile-menu-consignment-page-header'
      onBack={() => setPage('account')}
      to='/account/consignment'
      onPress={() => closeMenu()}
    >
      Consigning
    </HeaderMobileMenuHeader>
    <React.Suspense fallback={<Spinner/>}>
      <HeaderMobileMenuConsignmentPageContent closeMenu={closeMenu}/>
    </React.Suspense>
  </>;
};
